export const REPORT_SELECTABLE_DAYS = 31;

export const getJstTodayString = (date: Date = new Date()): string => {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
};

export const shiftDateString = (dateStr: string, days: number): string => {
  const [year, month, day] = dateStr.split('-').map(Number);
  const shifted = new Date(Date.UTC(year, month - 1, day + days));
  const y = shifted.getUTCFullYear();
  const m = String(shifted.getUTCMonth() + 1).padStart(2, '0');
  const d = String(shifted.getUTCDate()).padStart(2, '0');

  return `${y}-${m}-${d}`;
};

export const getDefaultReportDateRange = (): { startDate: string; endDate: string; minDate: string; maxDate: string } => {
  const maxDate = getJstTodayString();
  const minDate = shiftDateString(maxDate, -(REPORT_SELECTABLE_DAYS - 1));

  return {
    startDate: minDate,
    endDate: maxDate,
    minDate,
    maxDate,
  };
};

export const validateReportDateRange = (
  startDate: string,
  endDate: string,
  minDate: string,
  maxDate: string
): string | null => {
  if (!startDate || !endDate) {
    return '開始日と終了日を選択してください。';
  }

  if (startDate < minDate || endDate > maxDate) {
    return `期間は直近${REPORT_SELECTABLE_DAYS}日以内から選択してください。`;
  }

  if (startDate > endDate) {
    return '開始日は終了日以前の日付を選択してください。';
  }

  return null;
};

export const isDateWithinRange = (dateStr: string, startDate: string, endDate: string): boolean => {
  return dateStr >= startDate && dateStr <= endDate;
};

export const getJstDateStringFromDateTime = (value: string): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value.slice(0, 10);
  }

  return getJstTodayString(date);
};

export const formatDateRangeForFilename = (startDate: string, endDate: string): string => {
  const compact = (dateStr: string) => dateStr.replace(/-/g, '');

  if (startDate === endDate) {
    return compact(startDate);
  }

  return `${compact(startDate)}-${compact(endDate)}`;
};
